<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="church-welcome">
<h1>Church Welcome</h1>
<p style="text-indent: 00em;">Welcome, welcome here today, old and new</p>
<p style="text-indent: 00em;">We’re looking forward to spending this time with you</p>
<p style="text-indent: 00em;">We hope you will feel the love and care</p>
<p style="text-indent: 00em;">That surrounds everyone that is here</p>
<p style="text-indent: 00em;">Our prayer is that you will be blessed today</p>
<p style="text-indent: 00em;">And if you have any concerns at the end, let us pray</p>
<p style="text-indent: 00em;">Our lesson on James will continue after praise</p>
<p style="text-indent: 00em;">As we learn a lot more about his ways</p>
<p style="text-indent: 00em;">Please linger around a bit at the end</p>
<p style="text-indent: 00em;">For tea and coffee and sharing to spend</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch008.vue?1739e25c